function applyBorderRadius(image) {
  const height = image.clientHeight;
  const borderRadius = height / 2;
  // Set the border radius
  image.style.borderBottomLeftRadius = `${borderRadius}px`;
}

// Watch images for size changes
const ImageObserver = new ResizeObserver(entries => {
  // Update the border radius
  entries.forEach(entry => applyBorderRadius(entry.target));
});

// Have our Watcher observe the rounded media text class
DomObserver.observe('.js-rounded-media-text', blocks => {
  blocks.forEach(block => {
    // Find all the images in the block
    [...block.querySelectorAll('.js-media-text__image')].forEach(image => {
      // Watch the image for size changes
      ImageObserver.observe(image);
      // Apply the border radius
      applyBorderRadius(image);
    });
  });
});